module.exports = __webpack_public_path__ + "static/media/baseline-arrow_drop_down-24px.b4f9a56f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baseline-arrow_drop_down-24px.svg
// module id = 921
// module chunks = 58